
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mabar",
      function () {
        return require("private-next-pages/mabar/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mabar"])
      });
    }
  